import { IFormResponse } from '@bimser/common/src/components/Forms/entities';
import { findMessage } from '@bimser/components';
import { FormItemTypes, MLHelper } from '@bimser/core';

const sendIFrameJson = (): { result: IFormResponse } => ({
	result: {
		secretKey: 'secretKey',
		form: {
			data: {
				entities: {
					items: {
						Form1: {
							id: 'Form1',
							type: 'Form',
							parentId: '',
							designerProps: {
								layout: {}
							},
							items: ['Row1'],
							properties: {
								controlType: FormItemTypes.EContainerTypes.Form,
								session: null,
								tabIndex: 0,
								title: null,
								formType: 'standard',
								responseParameters: {
									workflowInfo: {
										processId: 0,
										currentStep: {
											key: 'd9faaafa-949d-4f6c-9f3b-bfea4e949c3d',
											name: 'FlowStart1',
											typeCode: 10
										},
										events: [
											{
												id: 4,
												description:
													findMessage.getAsMultiLanguageObject('100752'),
												default: false,
												reason: false,
												reasonTitle: null,
												validate: false,
												form: null,
												color: null,
												icon: 'event-send',
												enable: true,
												system: true,
												confirm: false,
												visible: true,
												digitalSignatureRequired: false,
												conditionsType: 0,
												conditionsValue: '0'
											}
										],
										event: null,
										flowStatus: 0,
										flowStatusCaptions: {},
										instanceId: null
									}
								},
								activeView: 'default',
								canSaveAsDraft: false,
								text: MLHelper.createMLObjectWithValue('Form1'),
								statuses: [],
								identityFormat: '<u>',
								identityFormatId: 0,
								copyPasteEnabled: false,
								versioningEnabled: false,
								publicFields: [],
								toolbarButtons: [
									{
										key: 'toolbarSaveButton',
										name: 'Kaydet',
										icon: 'save',
										enabled: true,
										validate: false,
										DefaultEnabled: true,
										caption: findMessage.getAsMultiLanguageObject('100620'),
										secretKey: 'secretKey'
									} as any
								],
								rules: {},
								readOnly: false,
								visible: true,
								clientVisible: true,
								enabled: true,
								clientEnabled: true,
								style: {
									padding: '',
									backgroundColor: 'rgba(255, 255, 255, 0)',
									backgroundImage: '',
									height: null
								},
								containerStyle: {
									padding: '',
									backgroundColor: '',
									backgroundImage: '',
									height: null
								},
								caption: {
									text: MLHelper.createMLObjectWithValue('Form1'),
									position: 'left',
									size: {
										width: 120,
										height: 27
									},
									font: {
										family: 'Source Sans Pro, sans-serif',
										size: '13',
										color: '#25241f',
										bold: false,
										italic: false,
										underline: false,
										strikethrough: false
									},
									visible: true,
									ellipsis: true,
									horizontalAlign: 'left',
									verticalAlign: 'middle',
									markSettings: {
										char: '',
										position: 'atFirst',
										style: {
											padding: '',
											backgroundColor: '',
											backgroundImage: '',
											height: null
										}
									},
									showColon: false
								} as any,
								loading: false,
								customClassName: '',
								contextMenuKey: null,
								controlId: null,
								name: 'Form1',
								serverEvents: [],
								clientEvents: []
							}
						},
						Row1: {
							id: 'Row1',
							type: 'Section',
							parentId: 'Form1',
							designerProps: {
								layout: {}
							},
							items: ['Column1'],
							properties: null
						},
						Column1: {
							id: 'Column1',
							type: 'Column',
							parentId: 'Row1',
							designerProps: {
								layout: {}
							},
							items: ['Iframe1'],
							properties: null
						},
						Iframe1: {
							id: 'Iframe1',
							type: 'Iframe',
							parentId: 'Column1',
							designerProps: {
								layout: {}
							},
							items: [],
							properties: {
								controlType: FormItemTypes.EControlTypes.Iframe,
								tabIndex: 0,
								title: null,
								url: '',
								fillForm: false,
								height: 200,
								targetName: '',
								visible: true,
								clientVisible: true,
								enabled: true,
								clientEnabled: true,
								style: {
									padding: '',
									backgroundColor: '',
									backgroundImage: '',
									height: null
								},
								containerStyle: {
									padding: '',
									backgroundColor: '',
									backgroundImage: '',
									height: null
								},
								caption: {
									text: MLHelper.createMLObjectWithValue('Iframe1') as any,
									position: 'left',
									size: {
										width: 120,
										height: 34
									},
									font: {
										family: 'Source Sans Pro, sans-serif',
										size: '13',
										color: '#25241f',
										bold: false,
										italic: false,
										underline: false,
										strikethrough: false
									},
									visible: true,
									ellipsis: true,
									horizontalAlign: 'left',
									verticalAlign: 'middle',
									markSettings: {
										char: '',
										position: 'atFirst',
										style: {
											padding: '',
											backgroundColor: '',
											backgroundImage: '',
											height: null
										}
									},
									showColon: false
								},
								loading: false,
								customClassName: '',
								contextMenuKey: '',
								controlId: 'd5b8eff6-7647-5d40-d47d-36ef4b5e89d2',
								name: 'Iframe1',
								serverEvents: [],
								clientEvents: []
							}
						}
					},
					ghostItems: {}
				},
				result: ['Form1'],
				description: ''
			}
		},
		status: 0,
		documentId: 0,
		formPanelId: null
	}
});

export default sendIFrameJson;
